import { ArrowRightIcon } from 'lucide-react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router'

import { BorderedRadioButton, Button, RadioGroup, usePageTitle } from 'slab'

import { CenteredLayout } from '../employer_onboarding/CenteredLayout'
import { useEmployer } from '../employer_onboarding/EmployerProvider'

export function OwnershipVerificationPage () {
  usePageTitle('Ownership information')
  const navigate = useNavigate()
  const { employer } = useEmployer()

  // Get employer name from context
  const employerName = employer?.name || 'your company'

  const form = useForm({
    defaultValues: {
      ownership_25_percent: '',
    },
    mode: 'onTouched'
  })

  const handleBack = () => {
    navigate('/employers/verification/owner_invitation/add-individual')
  }

  const handleContinue = () => {
    const data = form.getValues()
    if (data.ownership_25_percent === 'yes') {
      navigate('/employers/verification/owner_invitation/add-owners')
    } else if (data.ownership_25_percent === 'no') {
      navigate('/employers/verification/owner_invitation/confirm-details')
    }
  }

  return (
    <CenteredLayout>
      <CenteredLayout.Header
        heading='Ownership information'
        subheading="To ensure compliance with regulations, tell us more about your company's ownership structure."
        align='center'
      />

      <form onSubmit={form.handleSubmit(handleContinue)}>
        <CenteredLayout.Container>
          <div className='space-y-6'>
            <div className='text-left'>
              <p className='body-bold mb-6'>
                Does any one individual <strong>own 25% or more</strong> of {employerName}?
              </p>

              <RadioGroup
                name='ownership_25_percent'
                label=''
                layout='horizontal'
                gap={4}
              >
                <BorderedRadioButton
                  {...form.register('ownership_25_percent', {
                    required: 'Please select an option',
                  })}
                  value='yes'
                  label='Yes'
                  size='small'
                />
                <BorderedRadioButton
                  {...form.register('ownership_25_percent', {
                    required: 'Please select an option',
                  })}
                  value='no'
                  label='No'
                  size='small'
                />
              </RadioGroup>

              {form.formState.errors?.ownership_25_percent && (
                <p className='text-red-500 body mt-2'>
                  {form.formState.errors.ownership_25_percent.message}
                </p>
              )}
            </div>
          </div>
        </CenteredLayout.Container>

        <CenteredLayout.Buttons align='center'>
          <Button
            variant='secondary'
            onClick={handleBack}
            type='button'
          >
            Back
          </Button>
          <Button
            variant='primary'
            type='submit'
            rightIcon={ArrowRightIcon}
            disabled={!form.formState.isValid}
          >
            Continue
          </Button>
        </CenteredLayout.Buttons>
      </form>
    </CenteredLayout>
  )
}
